/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserSeasonProgressResponse
 */
export interface UserSeasonProgressResponse {
    /**
     * 
     * @type {string}
     * @memberof UserSeasonProgressResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserSeasonProgressResponse
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof UserSeasonProgressResponse
     */
    seasonPassId: string;
    /**
     * Sum of XP earned from pass-designated activities since the pass started.
     * @type {number}
     * @memberof UserSeasonProgressResponse
     */
    totalXP: number;
    /**
     * Tier numbers whose rewards have been claimed by the user.
     * @type {Array<number>}
     * @memberof UserSeasonProgressResponse
     */
    claimedTiers: Array<number>;
    /**
     * Highest tier fully crossed (totalXP >= tier.xpRequired). 0 if none yet reached.
     * @type {number}
     * @memberof UserSeasonProgressResponse
     */
    currentTierNumber: number;
    /**
     * Next tier to unlock. Null if all tiers completed.
     * @type {number}
     * @memberof UserSeasonProgressResponse
     */
    nextTierNumber?: number | null;
    /**
     * Cumulative XP required to reach the next tier. Null if all tiers completed.
     * @type {number}
     * @memberof UserSeasonProgressResponse
     */
    nextTierXpRequired?: number | null;
    /**
     * Progress toward the next tier expressed as 0–100.
     * @type {number}
     * @memberof UserSeasonProgressResponse
     */
    percentToNextTier?: number;
    /**
     * Most-recently-generated AI share copy for this user's latest tier unlock. Persisted by creditSeasonProgress at tier-unlock time so modal + share-card + OG meta all read the same text.
     * @type {string}
     * @memberof UserSeasonProgressResponse
     */
    lastShareCopy?: string;
    /**
     * Epoch ms — when lastShareCopy was generated
     * @type {number}
     * @memberof UserSeasonProgressResponse
     */
    lastShareCopyGeneratedAt?: number;
    /**
     * Tier number the lastShareCopy was generated for
     * @type {number}
     * @memberof UserSeasonProgressResponse
     */
    lastShareCopyTierNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof UserSeasonProgressResponse
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof UserSeasonProgressResponse
     */
    updatedAt: number;
}

/**
 * Check if a given object implements the UserSeasonProgressResponse interface.
 */
export function instanceOfUserSeasonProgressResponse(value: object): value is UserSeasonProgressResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('seasonPassId' in value) || value['seasonPassId'] === undefined) return false;
    if (!('totalXP' in value) || value['totalXP'] === undefined) return false;
    if (!('claimedTiers' in value) || value['claimedTiers'] === undefined) return false;
    if (!('currentTierNumber' in value) || value['currentTierNumber'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function UserSeasonProgressResponseFromJSON(json: any): UserSeasonProgressResponse {
    return UserSeasonProgressResponseFromJSONTyped(json, false);
}

export function UserSeasonProgressResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserSeasonProgressResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userId': json['userId'],
        'seasonPassId': json['seasonPassId'],
        'totalXP': json['totalXP'],
        'claimedTiers': json['claimedTiers'],
        'currentTierNumber': json['currentTierNumber'],
        'nextTierNumber': json['nextTierNumber'] == null ? undefined : json['nextTierNumber'],
        'nextTierXpRequired': json['nextTierXpRequired'] == null ? undefined : json['nextTierXpRequired'],
        'percentToNextTier': json['percentToNextTier'] == null ? undefined : json['percentToNextTier'],
        'lastShareCopy': json['lastShareCopy'] == null ? undefined : json['lastShareCopy'],
        'lastShareCopyGeneratedAt': json['lastShareCopyGeneratedAt'] == null ? undefined : json['lastShareCopyGeneratedAt'],
        'lastShareCopyTierNumber': json['lastShareCopyTierNumber'] == null ? undefined : json['lastShareCopyTierNumber'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function UserSeasonProgressResponseToJSON(json: any): UserSeasonProgressResponse {
    return UserSeasonProgressResponseToJSONTyped(json, false);
}

export function UserSeasonProgressResponseToJSONTyped(value?: UserSeasonProgressResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'seasonPassId': value['seasonPassId'],
        'totalXP': value['totalXP'],
        'claimedTiers': value['claimedTiers'],
        'currentTierNumber': value['currentTierNumber'],
        'nextTierNumber': value['nextTierNumber'],
        'nextTierXpRequired': value['nextTierXpRequired'],
        'percentToNextTier': value['percentToNextTier'],
        'lastShareCopy': value['lastShareCopy'],
        'lastShareCopyGeneratedAt': value['lastShareCopyGeneratedAt'],
        'lastShareCopyTierNumber': value['lastShareCopyTierNumber'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

